import { IconButton, Menu, Box, Spacer } from "@chakra-ui/react";
import { MdOutlineSettings, MdOutlineTimeline, MdOutlineLeaderboard, MdOutlineMap, MdChevronRight } from "react-icons/md";
import { useDashboardSettings } from "features/dashboard/settings/store";


const menuContentProps = {
  bg: "dashboard.bg.popover",
  color: "dashboard.fg.default",
  borderColor: "dashboard.border.default",
};

const menuItemProps = {
  _highlighted: { bg: "dashboard.bg.surfaceMuted" },
};

const activeItemProps = (isActive) => isActive
    ? { ...menuItemProps, bg: "dashboard.bg.surfaceMuted", fontWeight: "semibold", _hover: { bg: "dashboard.bg.surfaceMuted" } }
    : { ...menuItemProps, _hover: { bg: "dashboard.bg.surfaceSubtle" } };

const SettingsMenu = () => {
  const s = useDashboardSettings();
  if (!s.ready || s.portal !== "club") return null;

  const { campuses, nivelesForCampus, semestresForNivel } = s.options;

  return (
    <Menu.Root>
      <Menu.Trigger asChild>
        <IconButton type="button" variant="ghost" color="dashboard.fg.muted" rounded="full" aria-label="Settings">
          <MdOutlineSettings />
        </IconButton>
      </Menu.Trigger>

      <Menu.Positioner>
        <Menu.Content {...menuContentProps}>
          {/* Nivel */}
          <Menu.Root positioning={{ placement: "right-start", gutter: 2 }}>
            <Menu.TriggerItem value="nivel" {...menuItemProps}>
              <MdOutlineLeaderboard />
              <Box flex="1">Nivel</Box>
              <Spacer />
              <Box color="dashboard.fg.muted">
                <MdChevronRight />
              </Box>
            </Menu.TriggerItem>

            <Menu.Positioner>
              <Menu.Content {...menuContentProps}>
                {nivelesForCampus.map((n) => {
                  const isActive = n.id === s.nivelId
                  return (
                    <Menu.Item
                      key={n.id}
                      value={n.id}
                      onClick={() => s.setNivelId(n.id)}
                      {...activeItemProps(isActive)}
                    >
                      {n.nombre}
                    </Menu.Item>
                  )
                })}
              </Menu.Content>
            </Menu.Positioner>
          </Menu.Root>

          {/* Semestre */}
          <Menu.Root positioning={{ placement: "right-start", gutter: 2 }}>
            <Menu.TriggerItem value="semestre" {...menuItemProps}>
              <MdOutlineTimeline />
              <Box flex="1">Semestre</Box>
              <Spacer />
              <Box color="dashboard.fg.muted">
                <MdChevronRight />
              </Box>
            </Menu.TriggerItem>

            <Menu.Positioner>
              <Menu.Content {...menuContentProps}>
                {semestresForNivel.map((sem) => {
                  const isActive = sem.id === s.semestreId
                  return (
                    <Menu.Item
                      key={sem.id}
                      value={sem.id}
                      onClick={() => s.setSemestreId(sem.id)}
                      {...activeItemProps(isActive)}
                    >
                      {sem.codigo}
                    </Menu.Item>
                  )
                })}
              </Menu.Content>
            </Menu.Positioner>
          </Menu.Root>

          {/* Campus */}
          <Menu.Root positioning={{ placement: "right-start", gutter: 2 }}>
            <Menu.TriggerItem value="campus" {...menuItemProps}>
              <MdOutlineMap />
              <Box flex="1">Campus</Box>
              <Spacer />
              <Box color="dashboard.fg.muted">
                <MdChevronRight />
              </Box>
            </Menu.TriggerItem>

            <Menu.Positioner>
              <Menu.Content {...menuContentProps}>
                {campuses.map((c) => {
                  const isActive = c.id === s.campusId
                  return (
                    <Menu.Item
                      key={c.id}
                      value={c.id}
                      onClick={() => s.setCampusId(c.id)}
                      {...activeItemProps(isActive)}
                    >
                      {c.nombre}
                    </Menu.Item>
                  )
                })}
              </Menu.Content>
            </Menu.Positioner>
          </Menu.Root>
        </Menu.Content>
      </Menu.Positioner>
    </Menu.Root>
  );
};

export default SettingsMenu;
